<template>
  <e-charts
    ref="line"
    autoresize
    :options="option"
    theme="theme-color"
    auto-resize
  />
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/bar'
import theme from './theme.json'

ECharts.registerTheme('theme-color', theme)

export default {
  components: {
    ECharts,
  },
  props: {
    optionData: {
      type: Object,
      default: null,
    },
  },
  computed: {
    option() {
      if (!this.optionData) {
        return {}
      }
      return {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: this.optionData.legend || {
          left: 0,
        },
        grid: this.optionData.grid,
        xAxis: this.optionData.xAxis,
        yAxis: this.optionData.yAxis,
        series: this.optionData.series,
      }
    },
  },
  mounted() {
    // Trigger resize after mount to handle initial page load sizing
    this.$nextTick(() => {
      setTimeout(() => {
        this.resize()
      }, 100)
    })
  },
  methods: {
    resize() {
      if (this.$refs.line) {
        this.$refs.line.resize()
      }
    },
    getChartInstance() {
      if (this.$refs.line) {
        return this.$refs.line.chart || this.$refs.line
      }
      return null
    },
  },
}
</script>

<style>
.echarts {
  width: 100% !important;
}
</style>
